import { useCallback } from 'react';
import { segmentClient } from 'services/analytics/segment/segment';
import { VaroEvent } from 'shared/analytics/types/events';
import { enrich } from 'shared/analytics/utils/enrich';

export const useAnalytics = () => {
  const logEvent = useCallback(
    (event: VaroEvent, customProperties?: Record<string, unknown>) => {
      const properties = enrich({
        ...event.properties,
        ...customProperties,
      });
      return segmentClient.logEvent(event.key, properties);
    },
    [],
  );

  return { logEvent, flushEvents: segmentClient.flush };
};
